import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment'

import { Http, Response, Headers } from '@angular/http';
import { HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { Group } from '../../shared/models/group.model';
import * as Rx from 'rxjs/Rx'

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';


const API_URL = environment.apiUrl;
const MASTER_TOKEN = environment.masterToken;
const ADMIN_TOKEN = environment.adminToken

@Injectable()
export class ApiService {

  constructor(
    private http: Http
  ) { }

  private handleError (error: Response | any) {
    console.error('ApiService::handleError', error);
    return Observable.throw(error);
  }

  public getAllGroups() {
    // will use this.http.get()
    return this.http
    .get(API_URL + '/groups')
    .map(response => {
      const groups = response.json();
      return response.json();
    })
    .catch(this.handleError);
  }

  // API: POST /todos
  public createGroup(groupNew: Group,cid:string) {

    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Bearer '+ MASTER_TOKEN);
    let myParams = new URLSearchParams();
    myParams.append('_uid', '1');


    const req = this.http.post(API_URL+'/groups',JSON.stringify(groupNew),
    { headers: headers,params:myParams
    })
      .subscribe(
        res => {
          console.log(res);
          return res;
        },
        err => {
          console.log("Error occured"+err);
        }
      );
    
  }

  // API: GET /todos/:id
  public getGroupById(groupId: number) {
    // will use this.http.get()
  }

  // API: PUT /todos/:id
  public updateGroup(todo: Group) {
    // will use this.http.put()
  }

  // DELETE /todos/:id
  public deleteGroupById(groupId: number) {
    // will use this.http.delete()
  }

}




// WEBPACK FOOTER //
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/shared/services/api.service.ts